import { render } from "./GalleryPopUp.vue?vue&type=template&id=4b87435b&scoped=true"
import script from "./GalleryPopUp.vue?vue&type=script&lang=js"
export * from "./GalleryPopUp.vue?vue&type=script&lang=js"

import "./GalleryPopUp.vue?vue&type=style&index=0&id=4b87435b&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b87435b"]])

export default __exports__